import type { ReactNode } from 'react';

interface Props {
  label: ReactNode;
  children: ReactNode;
}

export function AdminField({ label, children }: Props) {
  return (
    <div className="adm-row">
      <label>{label}</label>
      {children}
    </div>
  );
}
